/**
 * @file 积分充值支付成功弹窗
 */
import React from 'react';
import {PaySuccessImgUrl} from '../MembershipModal/constants';
import styles from './PaySuccessModal.module.less';
import Modal from '@/components/common/Modal';
import {createCx} from '@/utils/cx';
import type {Order} from '@/services/commerce/entities/payment';

const cx = createCx(styles);

interface PaySuccessModalProps {
    open: boolean;
    result: Order['sku'] | null;
    showRightsPendingTip?: boolean;
    onClose: () => void;
}

const PaySuccessModal: React.FC<PaySuccessModalProps> = ({
    open,
    result,
    showRightsPendingTip,
    onClose,
}) => {
    if (!result) {
        return null;
    }

    return (
        <Modal open={open} onCancel={onClose} destroyOnHidden size="sm" title={null} footer={null}>
            <div className={cx('container')}>
                <div className={cx('imgWrapper')}>
                    <img src={PaySuccessImgUrl} className={cx('img')} />
                    <div className={cx('title')}>支付成功</div>
                </div>
                {result?.pointsIsImmediate && result.points && (
                    <div className={cx('desc')}>{result.points}积分 已发放</div>
                )}
                {showRightsPendingTip && <div className={cx('tips')}>权益预计于2分钟内生效</div>}
            </div>
        </Modal>
    );
};

export default PaySuccessModal;
